import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { H1, H4, Copyright, Icon, Button } from '../Common'

import style from './Page.scss'

import background from '../../images/horizon.jpg'
import woman from '../../images/woman.png'
import logoFacebook from '../../images/f_logo_RGB-White_1024.png'

const Background = styled.div`
  background-image: url(${background});
`

const Woman = styled.div`
  background-image: url(${woman});
`

const Page = ({ mobile, onInitialStep }) => (
  <div className={style.page}>
    <div className={style.wrapper}>
      <H1>Cadastre-se gratuitamente e alcance seus clientes em todos os canais</H1>
      <H4>
        Monitore e atenda seus clientes nas redes sociais. Obtenha insights para tomar decisões de marketing e negócios
        conectando-se agora!
      </H4>
      <Button
        id="button-login-facebook"
        href="/facebook_login"
        title="Fazer login com o Facebook"
        className={style.facebook}
        tabIndex={2}
        autoFocus
        xl
      >
        <img src={logoFacebook} alt="logotipo facebook" />
        Fazer login com o Facebook
      </Button>
      <div className={style.buttons}>
        <a
          onClick={() => onInitialStep()}
          title="Cadastrar usando e-mail"
          className={style.email}
          tabIndex={3}
          id="link-cadastro-email"
        >
          cadastrar usando e-mail <Icon value="keyboard_arrow_right" material />
        </a>
        {!mobile && (
          <Link to="/login" id="link-login" className={style.login} tabIndex={1}>
            login <Icon value="keyboard_arrow_right" material />
          </Link>
        )}
      </div>
      <Copyright />
    </div>
    <Background className={style.background} />
    <Woman className={style.woman} />
  </div>
)

Page.propTypes = {
  mobile: PropTypes.bool,
  onInitialStep: PropTypes.func.isRequired,
}

export default Page



// WEBPACK FOOTER //
// ./src/components/Signup/Page.js